package com.neurobs.ccabserver.transcriptreview.components.transcriptreview

import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{CommandRouterContext, ErrorState, TestTranscriptReviewStateGenerator, UserState, VisibilityStateGenerator}
import com.neurobs.js.ccab.ServerContext
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html._

import scala.concurrent.ExecutionContext.Implicits.global

@react
object TestTranscriptReviewOptions {

	case class Props()

	val component = FunctionalComponent[Props] { props =>

		val testTranscriptReviewState = TestTranscriptReviewStateGenerator.accessState

		div(className := "ui center aligned grid")(
			div(className := "eleven wide column")(
				LatencyToggleButton(buttonModifiers = "left floated"),
				ResolveWordOverlapButton(buttonModifiers = "left floated"),
				//SpectrogramDisplayButton(buttonModifiers = "left floated"),
				TranscriptTextVisibilityButton(buttonModifiers = "left floated"),
				PlayPauseButton(buttonModifiers = "left floated"),
			),
			div(className := "five wide column")(
				TranscriptSave(classString = "right floated")
			)
		)
	}
}

@react
object ResolveWordOverlapButton {

	case class Props(buttonModifiers: String = "")

	val component = FunctionalComponent[Props] { props =>

		val testState = TestTranscriptReviewStateGenerator.accessState

		def getClassname = s"ui ${props.buttonModifiers} button"//if (testState.hasWordOverlap()) "ui button" else "ui disabled button"
		def getOnClick: () => Unit = () => {
			if (testState.hasWordOverlap()) testState.resolveWordOverlap()
		}

		button(
			className := getClassname,
			onClick := getOnClick
		)("Resolve word overlap")
	}
}

@react
object PlayPauseButton {

	case class Props(buttonModifiers: String = "")

	val component = FunctionalComponent[Props] { props =>

		val testState = TestTranscriptReviewStateGenerator.accessState

		val widthStyle = StyleUtil.makeStyle(("width", "150px"))

		val playButton = {
			button(className := s"ui ${props.buttonModifiers} green icon button", style := widthStyle, onClick := {() => testState.playPause()})(
				i(className := "play icon")
			)
		}
		val pauseButton = {
			button(className := s"ui ${props.buttonModifiers} icon button", style := widthStyle, onClick := {() => testState.playPause()})(
				i(className := "pause icon")
			)
		}

		if (testState.audioIsPlaying) pauseButton
		else playButton
	}
}

@react
object SpectrogramDisplayButton {
	case class Props(buttonModifiers: String = "")

	val component = FunctionalComponent[Props] { props =>

		val visibilityState = VisibilityStateGenerator.accessState

		def spectrogramIsVisible = visibilityState.spectrogramIsVisible
		def toggleSpectrogramVisibility() = visibilityState.toggleSpectrogramVisibility()

		def buttonClass = s"ui ${props.buttonModifiers} ${if (spectrogramIsVisible) "primary" else ""} button"

		button(
			className := buttonClass,
			onClick := {() => toggleSpectrogramVisibility()}
		)(
			if (spectrogramIsVisible) "Hide spectrogram"
			else "Show spectrogram"
		)
	}
}

@react
object TranscriptTextVisibilityButton {
	case class Props(buttonModifiers: String = "")

	val component = FunctionalComponent[Props] { props =>

		val visibilityState = VisibilityStateGenerator.accessState

		def transcriptTextIsVisible = visibilityState.transcriptTextIsVisible
		def toggleTranscriptTextVisibility() = visibilityState.toggleTranscriptTextVisibility()

		def buttonClass = s"ui ${props.buttonModifiers} ${if (transcriptTextIsVisible) "primary" else ""} button"

		button(
			className := buttonClass,
			onClick := {() => toggleTranscriptTextVisibility()}
		)(
			if (transcriptTextIsVisible) "Hide transcript text"
			else "Show transcript text"
		)
	}
}

@react
object LatencyToggleButton {
	case class Props(buttonModifiers: String = "")

	val component = FunctionalComponent[Props] { props =>

		val testTranscriptReviewState = TestTranscriptReviewStateGenerator.accessState

		def forLatency = testTranscriptReviewState.latency.value
		def toggleLatency() = testTranscriptReviewState.latency.toggle()

		div(
			className := s"ui ${if (forLatency) "primary" else ""} ${props.buttonModifiers} button",
			onClick := {() => toggleLatency()}
		)(
			if (forLatency) "Turn off latency review" else "Turn on latency review"
		)
	}
}

@react
object TranscriptSave {

	case class Props(classString: String = "")

	val component = FunctionalComponent[Props] { props =>

		val userState = UserState.accessState
		val commandRouter = CommandRouterContext.accessState()
		//val transcriptSelectionState = TranscriptSelectionState.accessState
		val testState = TestTranscriptReviewStateGenerator.accessState
		implicit val errorState = ErrorState.accessState
		implicit val server = ServerContext.accessState()

		val (awaitingServerResponse, setAwaitingServerResponse) = useState(false)

		//def reviewIsIncomplete = testTranscriptReviewState.unreviewedRecordings.length > 0

		//def showIncompleteAlert = testTranscriptReviewState.displayingUnreviewedAlert

		def handleSaveClick() = {
//      if (reviewIsIncomplete) {
//        testTranscriptReviewState.showUnreviewedAlert()
//      } else {
				saveReviewedTestTranscript()
//      }
		}

		def saveReviewedTestTranscript(): Unit = {
			val userId = userState.userId
			val username = userState.username
			//errorState.addError("This is a test error message.")
			testState.saveReviewedTranscript(userId = userId, username = username) map { res =>
				res match {
					case Left(error) =>
						errorState.addError(error.description)
					case Right(data) =>
						//println(s"reviewed transcript ${data.id}")
						commandRouter.updateSelectionList(data)
				}
				setAwaitingServerResponse(false)
			}
			setAwaitingServerResponse(true)
		}

		if (awaitingServerResponse) {
			button(
				className := s"ui ${props.classString} primary loading button",
			)
		} else {
			button(
				className := s"ui ${props.classString} primary button",
				onClick := {() => handleSaveClick()}
			)(
				"Save Reviewed Test Transcript"
			)
		}
	}
}
